import service from '../index'
import { Message } from 'element-ui'

export default [
  response => response,
  error => {
    const config = error.config
    // 判断是否配置了 retry
    if (!config || !config.retry) return Promise.reject(error)

    // 设置重试次数，默认为 0
    config.__retryCount = config.__retryCount || 0

    // 判断是否超过了重试次数
    if (config.__retryCount >= config.retry) {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000,
      })
      return Promise.reject(error)
    }

    // 重试次数自增
    config.__retryCount += 1

    // 延时处理
    const delayRetry = new Promise(resolve => {
      setTimeout(() => resolve(), config.retryDelay || 0)
    })

    // 重新发起请求
    return delayRetry.then(() => service(config))
  },
]
